export const EstadoReciboSAT = [
    {
        estado: "Recibido",
        nombre: "Recibido",
        codigo: 1
    }, {
        estado: "Anulado",
        nombre: "Anulado",
        codigo: 2
    }, {
        estado: "Procesado",
        nombre: "Procesado",
        codigo: 3
    }, {
        estado: "Gestionado",
        nombre: "Gestionado",
        codigo: 4
    }, {
        estado: "Error",
        nombre: "Error",
        codigo: 5
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general_recibo/modelo/EstadoReciboSAT.ts